import _ from 'underscore';
import { useContext, useMemo } from 'react';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';

export const getPilotValueWithSignUp = (serverContext, key) => {
  const ccuiPilotKey = key && key.replace(/^Is/, 'is');
  const ccDynamicPilotKey = key && key.replace(/^(is|Is)/, '').replace(/Enabled$/, '');
  // CCUIPilots only return by signup page
  const ccuiPilotValue = _.get(serverContext, ['CCUIPilots', ccuiPilotKey], false);
  const ccuiPilotValueWithDynamic = _.get(serverContext, ['CCUIPilots', 'dynamic', ccDynamicPilotKey], false);

  return ccuiPilotValue || ccuiPilotValueWithDynamic;
};

export const getPilotValue = (serverContext, key) => {
  const cmuiPilotKey = key && key.replace(/^is/, 'Is');
  const uflPilotKey = key && key.replace(/^(is|Is)/, '').replace(/Enabled$/, ''); // ufl stands for Unified Feature Library

  const cmuiPilotValue = _.get(serverContext, ['Permissions', cmuiPilotKey], false);
  const uflPilotValue = _.get(serverContext, ['DynamicPermissions', uflPilotKey], false);

  const signupPilotValue = getPilotValueWithSignUp(serverContext, key);

  return cmuiPilotValue || uflPilotValue || signupPilotValue;
};

export function usePilotsValue(key, onlySignup = false) {
  const serverContext = useContext(ServerContext);
  const getPilot = onlySignup ? getPilotValueWithSignUp : getPilotValue;
  const isPilotEnabled = useMemo(
    () => (key ? getPilot(serverContext, key) : false),
    [key, serverContext, getPilot]
  );

  return isPilotEnabled;
}

export const useIsInternalUser = () => {
  const serverContext = useContext(ServerContext);
  if (serverContext.CurrentUser && !_.isUndefined(serverContext.CurrentUser.IsInternal)) {
    return serverContext.CurrentUser.IsInternal;
  }
  return serverContext.IsInternal || false;
};

export const useIsReadOnlyUser = () => {
  const isReadOnly = usePilotsValue('IsReadOnlyUser');

  const isDSAEnforcementEnabled = usePilotsValue('DSAEnforcement');
  const serverContext = useContext(ServerContext);
  const enforcementActionId = _.get(serverContext, ['CurrentUser', 'EnforcementActionId']);
  const isDSAReadOnly = isDSAEnforcementEnabled && enforcementActionId === Constants.EnforcementActionType.ReadOnly;

  return isReadOnly || isDSAReadOnly;
};
